import styled from 'styled-components';

export const MessageTableData = styled.td`
    padding: 8px;
    border: 1px solid;
`;

export const MessageIconContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;